"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.vw = exports.rdp = void 0;
var _validates_1 = require("./_validates");
var errors_1 = require("./errors");
var utils_1 = require("./utils");
var _dist2 = function (p1, p2) {
    return Math.pow((p1[0] - p2[0]), 2) + Math.pow((p1[1] - p2[1]), 2);
};
var _perpendicular = function (p1, p2, target) {
    var a = (p1[1] - p2[1]) / (p1[0] - p2[0]);
    var b = -a * p2[0] + p2[1];
    return Math.abs(a * target[0] - target[1] + b) / Math.pow((Math.pow(a, 2) + 1), 0.5);
};
var _rdpCandidates = function (first, last, linearRing, threshold, area) {
    var memory = -Infinity;
    var index = -1;
    for (var i = first + 1; i < last; i++) {
        var a = area ? (0, utils_1.area)([linearRing[first], linearRing[i], linearRing[last], linearRing[first]]) :
            _perpendicular(linearRing[first], linearRing[last], linearRing[i]);
        if (a > memory) {
            memory = a;
            index = i;
        }
    }
    if (memory < threshold)
        return [];
    return __spreadArray(__spreadArray([
        {
            index: index,
            score: memory
        }
    ], _rdpCandidates(first, index, linearRing, threshold, area), true), _rdpCandidates(index, last, linearRing, threshold, area), true);
};
function rdp(linearRing, userOptions) {
    /*
    Modified Ramer–Douglas–Peucker
  
    Original Algorithm
    https://en.wikipedia.org/wiki/Ramer%E2%80%93Douglas%E2%80%93Peucker_algorithm
    */
    (0, _validates_1.validLinearRing)(linearRing);
    var options = Object.assign({
        area: false,
        threshold: 0.001,
        limit: Infinity
    }, userOptions);
    if (options.area) {
        if (options.threshold < 0 || options.threshold >= 1)
            throw new errors_1.InvalidSimplifyError("when area is true, threshold must be between 0 and 1.");
    }
    else {
        if (options.threshold < 0)
            throw new errors_1.InvalidSimplifyError("threshold must be positive number.");
    }
    if (options.limit < 4)
        throw new errors_1.InvalidSimplifyError("limit must be larger than 3.");
    var threshold = options.area ? (0, utils_1.area)(linearRing) * options.threshold : options.threshold;
    var first = 0;
    var last = linearRing.length - 1;
    var score = -Infinity;
    var midpoint = -1;
    for (var i = first + 1; i < last; i++) {
        var d2 = _dist2(linearRing[first], linearRing[i]);
        if (d2 > score) {
            score = d2;
            midpoint = i;
        }
    }
    var candidates = __spreadArray(__spreadArray([], _rdpCandidates(first, midpoint, linearRing, threshold, options.area), true), _rdpCandidates(midpoint, last, linearRing, threshold, options.area), true);
    if (options.limit < linearRing.length) {
        candidates.sort(function (a, b) {
            return (a.score < b.score ? 1 : -1);
        });
        candidates = candidates.slice(0, options.limit - 3);
    }
    var candidateIndexes = __spreadArray([first, last, midpoint], candidates.map(function (v) { return v.index; }), true);
    return linearRing.filter(function (_, i) {
        return candidateIndexes.includes(i);
    });
}
exports.rdp = rdp;
function vw(linearRing, userOptions) {
    /*
    Modified Visvalingam–Whyatt
  
    Original Algorithm
    https://en.wikipedia.org/wiki/Visvalingam%E2%80%93Whyatt_algorithm
    */
    (0, _validates_1.validLinearRing)(linearRing);
    var options = Object.assign({
        rate: false,
        threshold: 0.001,
        limit: Infinity
    }, userOptions);
    if (options.rate) {
        if (options.threshold < 0 || options.threshold >= 1)
            throw new errors_1.InvalidSimplifyError("when rate is true, threshold must be between 0 and 1.");
    }
    else {
        if (options.threshold < 0)
            throw new errors_1.InvalidSimplifyError("threshold must be positive number.");
    }
    if (options.limit < 4)
        throw new errors_1.InvalidSimplifyError("limit must be larger than 3.");
    var threshold = options.rate ? (0, utils_1.area)(linearRing) * options.threshold : options.threshold;
    var candidates = linearRing.map(function (point, i) {
        if (i === 0 || i === linearRing.length - 1)
            return {
                score: Infinity,
                index: i
            };
        return {
            score: (0, utils_1.area)([linearRing[i - 1], point, linearRing[i + 1], linearRing[i - 1]]),
            index: i
        };
    });
    while (candidates.length > 4) {
        var score = Infinity;
        var eliminate = -1;
        for (var i = 1; i < candidates.length - 1; i++) {
            if (candidates[i].score < score) {
                score = candidates[i].score;
                eliminate = i;
            }
        }
        if (candidates.length > options.limit || score < threshold) {
            if (eliminate - 2 >= 0) {
                var p1 = candidates[eliminate - 2].index;
                var p2 = candidates[eliminate - 1].index;
                var p3 = candidates[eliminate + 1].index;
                candidates[eliminate - 1].score = (0, utils_1.area)([
                    linearRing[p1], linearRing[p2], linearRing[p3], linearRing[p1]
                ]);
            }
            if (eliminate + 2 <= candidates.length - 1) {
                var p1 = candidates[eliminate - 1].index;
                var p2 = candidates[eliminate + 1].index;
                var p3 = candidates[eliminate + 2].index;
                candidates[eliminate + 1].score = (0, utils_1.area)([
                    linearRing[p1], linearRing[p2], linearRing[p3], linearRing[p1]
                ]);
            }
            candidates.splice(eliminate, 1);
        }
        else {
            break;
        }
    }
    var candidateIndexes = __spreadArray([], candidates.map(function (v) { return v.index; }), true);
    return linearRing.filter(function (_, i) {
        return candidateIndexes.includes(i);
    });
}
exports.vw = vw;
